__turbopack_context__.v({
  "category": "_0-WU8W_category",
  "categoryIcon": "_0-WU8W_categoryIcon",
});
